import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
  palette: {
    primary: {
      light: '#122E01',
      main: '#389203',
      dark: '#5fa735',
      contrastText: '#fff',
    },
    secondary: {
      light: '#ffcf50',
      main: '#fc9e15',
      dark: '#c36f00',
      contrastText: '#000',
    },
    white: {
      main: '#FFFFFF'
    },
  },
  button: {
    outline: 'none'
  },

  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontSize: 14,
    body1: {
      fontSize: '0.9rem',
      fontWeight: 500
    },
    button: {
      fontSize: '1rem',
      fontWeight: 500,
      textTransform: 'capitalize',
      boxShadow: 'none'
    }
  },
});

export default theme;